// frontend/src/components/chat/FileUploadButton.jsx
// File upload button for chat attachments

import React, { useRef } from "react";
import {
  validateFile,
  ALLOWED_MIME_TYPES,
} from "../../utils/chatAttachmentApi";

const FileUploadButton = ({ onFileSelect, disabled = false }) => {
  const fileInputRef = useRef(null);

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // Validate file
    const validation = validateFile(file);
    if (!validation.valid) {
      alert(validation.error);
      // Reset input
      e.target.value = "";
      return;
    }

    onFileSelect(file);
    // Reset input so same file can be selected again
    e.target.value = "";
  };

  // Build accept string from allowed types
  const acceptTypes = ALLOWED_MIME_TYPES.join(",");

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        accept={acceptTypes}
        onChange={handleFileChange}
        style={{ display: "none" }}
        aria-hidden="true"
      />
      <button
        type="button"
        className="chat-attach-btn"
        onClick={handleClick}
        disabled={disabled}
        title="Attach file"
        aria-label="Attach file"
      >
        <i className="bi bi-paperclip"></i>
      </button>
    </>
  );
};

export default FileUploadButton;
